'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorMessage(props) {
    var message = props.message,
        dataTn = props.dataTn,
        className = props.className;


    if (!message) {
        return null;
    }

    return (typeof message === 'undefined' ? 'undefined' : (0, _typeof3.default)(message)) === 'object' && message.hasOwnProperty('__html') ? _react2.default.createElement('div', {
        'data-tn': dataTn,
        className: className,
        dangerouslySetInnerHTML: message
    }) : _react2.default.createElement(
        'div',
        { 'data-tn': dataTn, className: className },
        message
    );
}

exports.default = ErrorMessage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/Common/ErrorMessage.js
// module id = ./node_modules/dibs-elements/lib/Common/ErrorMessage.js
// module chunks = 4